import { useEffect, useState } from "react";
import { fetchBlogs } from "../services/blogService";
import BlogCard from "./BlogCard";

export default function PopularBlogs({ tag }) {
  const [blogs, setBlogs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3); 

  useEffect(() => {
    const load = async () => {
      const data = await fetchBlogs("All");

      const popular = (data || [])
        .filter((blog) =>
            blog.keywords?.includes(tag || "")
        )
        .sort(
          (a, b) =>
            new Date(b.blogDisplayDate) -
            new Date(a.blogDisplayDate)
        ); 

      setBlogs(popular);
    };

    load();
  }, [tag]);

  const visibleBlogs = blogs.slice(0, visibleCount);

  if (!blogs.length) return null;

  return (
    <div className="popular-wrapper">

      <div className="blog-grid">
        {visibleBlogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>

  
      {visibleCount < blogs.length && (
        <div className="show-more-wrapper">
          <button
            className="show-more-btn"
            onClick={() => {
              setVisibleCount((prev) =>
                Math.min(prev + 3, blogs.length)
              );
              window.scrollBy({ top: 200, behavior: "smooth" });
            }}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
}